import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["colorInput", "textInput", "resetButton"];
  static values = { resettable: Boolean };

  connect() {
    this._boundSetValue = this._handleSetValue.bind(this);
    this.element.addEventListener('promote:color-picker:set', this._boundSetValue);
  }

  disconnect() {
    this.element.removeEventListener('promote:color-picker:set', this._boundSetValue);
  }

  _handleSetValue(e) {
    const color = e.detail?.value;

    if (color) {
      this.setValue(color, { dispatchEvent: false });
    }
  }

  onColorChange(e) {
    const color = e.target.value.toUpperCase();

    this.setValue(color);
  }

  onTextChange(e) {
    let color = e.target.value.trim().toUpperCase();

    if (color && !color.startsWith('#')) { color = '#' + color; }

    // Validate hex color (3 or 6 characters)
    if (/^#[0-9A-F]{6}$/.test(color)) {
      this.setValue(color);
    } else if (/^#[0-9A-F]{3}$/.test(color)) {
      const expanded = `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`;

      this.setValue(expanded);
    }
  }

  setValue(color, options = {}) {
    const normalizedColor = color.toUpperCase();
    const { dispatchEvent = true } = options;

    this.colorInputTarget.value = normalizedColor;
    this.textInputTarget.value = normalizedColor;

    this._updateResetButtonVisibility(normalizedColor);

    if (dispatchEvent) {
      this._dispatchChangeEvent();
    }
  }

  reset() {
    this.setValue('#FFFFFF');
  }

  getValue() {
    return this.textInputTarget.value;
  }

  _updateResetButtonVisibility(color) {
    if (!this.resettableValue || !this.hasResetButtonTarget) return;

    if (color === '#FFFFFF') {
      this.resetButtonTarget.classList.add('hidden');
    } else {
      this.resetButtonTarget.classList.remove('hidden');
    }
  }

  _dispatchChangeEvent() {
    const event = new CustomEvent('promote:color-picker:change', {
      detail: { value: this.textInputTarget.value },
      bubbles: true
    });

    this.element.dispatchEvent(event);
  }
}
